import React from 'react';
export function AIFeed() {
  return null;
}